export default __webpack_public_path__ + "static/timweLogo-7a03d755894193fb4ddcded15f9c5986.png";